import type { DocumentReference, Reference } from '@medplum/fhirtypes'
import type { ExtendedDocumentReference } from '@seen/core/models/document-references/documentReferences'
import type { JSX } from 'react'
import { Sheet } from '#src/components/core/sheet/Sheet.tsx'
import { SheetContent } from '#src/components/core/sheet/SheetContent.tsx'
import { DocumentReferenceDisplay } from '#src/components/document-reference/DocumentReferenceDisplay.tsx'

interface DocumentReferenceSheetProps {
  documentReference?: ExtendedDocumentReference | null
  open: boolean
  setOpen: (open: boolean) => void
  hideDelete?: boolean
  hideParticipant?: boolean
  onReviewComplete?: (documentReference: Reference<DocumentReference>) => void
}

export function DocumentReferenceSheet({
  documentReference,
  open,
  setOpen,
  hideDelete = false,
  hideParticipant = false,
  onReviewComplete,
}: DocumentReferenceSheetProps): JSX.Element {
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="w-[85%] max-w-xl p-5">
        {documentReference && (
          <DocumentReferenceDisplay
            documentReference={documentReference.reference}
            onDelete={() => setOpen(false)}
            hideDelete={hideDelete}
            hideParticipant={hideParticipant}
            onReviewComplete={onReviewComplete}
          />
        )}
      </SheetContent>
    </Sheet>
  )
}
